var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollaborationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.268555,
    y: 0.401299,
    width: 64,
    height: 64,
    rx: 19.1837,
    fill: "#E8F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9079 32.8953C21.3239 32.8953 23.2825 30.9367 23.2825 28.5206C23.2825 26.1046 21.3239 24.146 18.9079 24.146C16.4918 24.146 14.5332 26.1046 14.5332 28.5206C14.5332 30.9367 16.4918 32.8953 18.9079 32.8953Z",
    stroke: "#00A3FA",
    strokeWidth: 1.79847,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9075 35.8118C16.587 35.8118 14.3616 36.7336 12.7208 38.3744C11.08 40.0153 10.1582 42.2407 10.1582 44.5611H15.1838",
    stroke: "#00A3FA",
    strokeWidth: 1.79847,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5863 32.8953C43.1702 32.8953 41.2116 30.9367 41.2116 28.5206C41.2116 26.1046 43.1702 24.146 45.5863 24.146C48.0023 24.146 49.9609 26.1046 49.9609 28.5206C49.9609 30.9367 48.0023 32.8953 45.5863 32.8953Z",
    stroke: "#00A3FA",
    strokeWidth: 1.79847,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5866 35.8118C47.9071 35.8118 50.1325 36.7336 51.7733 38.3744C53.4141 40.0153 54.3359 42.2407 54.3359 44.5611H49.3103",
    stroke: "#00A3FA",
    strokeWidth: 1.79847,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2963 28.9935C35.5325 28.9935 38.156 26.37 38.156 23.1338C38.156 19.8975 35.5325 17.274 32.2963 17.274C29.06 17.274 26.4365 19.8975 26.4365 23.1338C26.4365 26.37 29.06 28.9935 32.2963 28.9935Z",
    stroke: "#00A3FA",
    strokeWidth: 1.79847,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5762 44.6194C20.5762 41.5112 21.8109 38.5303 24.0087 36.3325C26.2066 34.1347 29.1875 32.8999 32.2957 32.8999C35.4039 32.8999 38.3848 34.1347 40.5826 36.3325C42.7805 38.5303 44.0152 41.5112 44.0152 44.6194H20.5762Z",
    stroke: "#00A3FA",
    strokeWidth: 1.79847,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborationIcon);
export default __webpack_public_path__ + "static/media/collaboration-icon.4401a4605ba26a84732452f903f9fcc6.svg";
export { ForwardRef as ReactComponent };